import { z } from 'zod';
import { isString } from 'utils/tsHelpers';
import { ESIndex } from '../../types';
import { useQueryStateContext } from '../../contexts';

const HANDLEBAR_REGEX = /\{{2}.*\}{2}/i;

export const useValidateForHandlebarValue = () => {
  const { esIndex } = useQueryStateContext();
  return ({ value }: Partial<{ value: string }>, addIssue: (arg: z.IssueData) => void) => {
    if (esIndex === ESIndex.Catalog && isString(value) && !!HANDLEBAR_REGEX.test(value)) {
      addIssue({
        code: z.ZodIssueCode.custom,
        message: 'cannot use handlebars for string input',
        path: ['value'],
      });
    }
  };
};
